/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:52:14
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-11-02 02:34:31
 */

import { Injectable } from "@angular/core";
import { ToastController, AlertController } from "ionic-angular";

@Injectable()
export class AlertService {
  private alert;
  private callbackToastErrorMessage: any;

  constructor(
    private alertCtrl: AlertController,
    private toastCtrl: ToastController
  ) {}

  public hookToastErrorMessage(callback) {
    this.callbackToastErrorMessage = callback;
  }
  public showToastErrorMessage(error: Object) {
    const message = (error && error["message"]) || "알 수 없는 에러 발생";
    if (this.callbackToastErrorMessage) {
      this.callbackToastErrorMessage(message);
    } else {
      this.showToastMessage(message);
    }
  }

  public showToastMessage(message, isBottom?: boolean) {
    this.toastCtrl
      .create({
        message: message,
        duration: 3000,
        position: isBottom ? "bottom" : "middle"
        // showCloseButton: false,
        // closeButtonText: '닫기',
        // cssClass: 'toast',
      })
      .present();
  }

  public showConfirmMessage(
    title: string,
    subTitle: string,
    callback: any,
    enabledDismiss = true
  ) {
    if (this.alert) return;

    const buttons = [];

    if (enabledDismiss) {
      buttons.push({
        text: "취소",
        role: "cancel"
      });
    }
    buttons.push({
      text: "확인",
      handler: () => {
        callback();
      }
    });

    this.alert = this.alertCtrl.create({
      title: title,
      message: subTitle,
      enableBackdropDismiss: enabledDismiss,
      buttons: buttons
      // cssClass: 'alert'
    });
    this.alert.present();
    this.alert.onDidDismiss(() => {
      this.alert = null;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/alert.service.ts